define('base/collectionview',['require','exports','module','base/view','base/vent','underscore'],function(require, exports, module) {
  "use strict";

  var View = require("base/view"),
      Vent = require("base/vent"),
      _ = require("underscore");

  var CollectionView = View.extend({
    constructor: function(options) {
      options = options || {};
      this._childViews = [];
      this.childVent = new Vent();
      options.noBinding = true;
      CollectionView.__super__.constructor.apply(this, arguments);
      if (this.collection && this.collection.on) {
        this.setCollectionListeners();
      }
    },
    setCollectionListeners: function() {
      this.listenTo(this.collection, "add", this.addChildView);
      this.listenTo(this.collection, "remove", this.removeChildView);
      this.listenTo(this.collection, "sort", this.render);
      this.listenTo(this.collection, "reset", this.render);
    },
    collectionIterator: function(collection, fn, ctx) {
      collection.each(fn, ctx);
    },
    createItemView: function(data) {
      return new this.itemView({model: data, parent: this});
    },
    addChildView: function(model) {
      if (!this.$container || !model) { return; }
      if (this._empty && this.collection.length === 1) {
        this._empty = false;
        return this.render();
      }
      var itemView = this.createItemView(model);
      this._childViews.push(itemView);
      this.childVent.stopListening(itemView);
      this.childVent.listenTo(
        itemView,
        "all",
        _.bind(this._childTrigger, this, itemView)
      );
      this.$container.append(itemView.render().el);
      itemView.triggerMethod("show");
      this.triggerMethod("add:child:view", itemView);
      return itemView;
    },
    findView: function(model) {
      return _.filter(this._childViews, function(v) { return v.model === model; });
    },
    removeChildView: function(model) {
      var toRemove = this.findView(model);
      _.invoke(toRemove, "remove");
      this._childViews = _.difference(this._childViews, toRemove);
      if (this.collection.length === 0) {
        this.render();
      }
    },
    renderEmptyView: function() {
      var emptyView,
          $container;
      if (this.emptyViewType) {
        this._empty = true;
        emptyView = new this.emptyViewType({parent: this});
        $container = this.emptyViewContainer? this.$(this.emptyViewContainer) : this.$el;
        $container.empty().append(emptyView.render().el);
      }
    },
    render: function(collection) {
      collection = collection || this.collection || [];
      if (this.template) {
        CollectionView.__super__.render.apply(this, arguments);
      }
      if (this.$container) { this.$container.empty(); }
      this.$container = this.itemContainer? this.$(this.itemContainer) : this.$el;
      _.invoke(this._childViews, "remove");
      this._childViews = [];
      this.childVent.stopListening();
      if (collection.length > 0) {
        this.collectionIterator(collection, this.addChildView, this);
      } else {
        this.renderEmptyView();
      }
      this.triggerMethod("render");
      return this;
    },
    _childTrigger: function(itemView, event) {
      var args = [].slice.call(arguments, 2),
          triggerArgs = [event, itemView].concat(args);
      this.childVent.trigger.apply(this.childVent, triggerArgs);
    },
    delegateEvents: function() {
      CollectionView.__super__.delegateEvents.apply(this, arguments);
      _.invoke(this._childViews, "delegateEvents");
    },
    remove: function() {
      module.exports.__super__.remove.call(this);
      _.invoke(this._childViews, "remove");
    }
  });

  module.exports = CollectionView;

});

